import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import TrustBar from './components/TrustBar';
import WhatIsSection from './components/WhatIsSection';
import HowItWorksSection from './components/HowItWorksSection';
import GuidesSection from './components/GuidesSection';
import ArticlesSection from './components/ArticlesSection';
import ProductsSection from './components/ProductsSection';
import CTASection from './components/CTASection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategoriesSection />
        <ProductsSection />
        <WhatIsSection />
        <HowItWorksSection />
        <GuidesSection />
        <ArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}